import { jsx } from "react/jsx-runtime";
import { STEP_CONFIGS, LAYOUT } from "./constants.js";
function TitleStepSvg({ stepIndex, isAbsolute = false }) {
  const config = STEP_CONFIGS[stepIndex];
  if (!config) return null;
  if (isAbsolute) {
    return /* @__PURE__ */ jsx("div", { className: "absolute", style: { left: LAYOUT.stepSvgLeft, top: LAYOUT.stepSvgTop, zIndex: 1 }, children: /* @__PURE__ */ jsx("img", { src: config.svg, alt: "", width: config.svgWidth, height: config.svgHeight }) });
  }
  return /* @__PURE__ */ jsx("div", { style: { padding: `0 ${LAYOUT.step1SvgPadding}px` }, children: /* @__PURE__ */ jsx("img", { src: config.svg, alt: "", width: config.svgWidth, height: config.svgHeight }) });
}
export {
  TitleStepSvg
};
//# sourceMappingURL=TitleStepSvg.js.map
